import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../comp/Header";
import Loading from "../comp/Loading";
import About from "../comp/About";
import Services from "../comp/Services";
import Skills from "../comp/Skills";
import Education from "../comp/Education";
import Portfolio from "../comp/portfolio/Portfolio";
import Contact from "../comp/Contact";
import Testimonial from "../comp/testimonials/Testimonial";
import Plans from "../comp/Plans";
import Footer from "../comp/Footer";

const Home = () => {
  const [load, setLoad] = useState(true);
  const location = useLocation();
  

  useEffect(() => {
    setTimeout(() => {
      setLoad(false);
    }, 1200);
  }, []);

  useEffect(() => {
    if (!load) { // Espera a que la página cargue
      if (location.hash) {
        const element = document.getElementById(location.hash.substring(1)); // Quita el "#" del hash
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, [location, load]); // Se ejecuta cuando cambia la URL o cuando termina de cargar


  if (load) {
    return <Loading />;
  }

  return (
    <>
      <div className="home">
        <Header />
        <About/>
        {/* <Services/> */}
        <Skills/>
        <Education/>
        <Portfolio id="portfolio"/>
        {/* <Testimonial/> */}
        {/* <Plans/> */}
        <Contact/>
        <Footer/>
      </div>
    </>
  );
};

export default Home;
